import { imageUrlWithSize, type SingleStore } from '@mybonus/public';
import { useState, useEffect, ReactNode } from 'react';

import { OfferList } from '../OfferList';
import { GiftcardDescription } from './GiftcardDescription';
import { GiftcardPurchase } from './GiftcardPurchase';
import { NetworkDescription } from './NetworkDescription';
import {
	$FloatBox,
	Logo,
	$Center,
	RedirectButton,
	FavoriteWrapper,
	$Waiter,
} from './StoreCard.parts';
import { StoreFavorite } from './StoreFavorite/StoreFavorite';

export type StoreCardProps = {
	store?: SingleStore;
	isLoading: boolean;
	isDisabled?: boolean;
	onProceedClick?: () => void;
	proceedButtonText?: string;
	giftcardPurchaseSectionOverride?: ReactNode;
};

export function StoreCard(props: StoreCardProps) {
	const { store } = props;
	const [collapseOffers, setCollapseOffers] = useState(true);

	useEffect(() => {
		if (store?.offers.length && store?.offers.length < 3) {
			setCollapseOffers(false);
		}
	}, [store?.offers.length]);

	return (
		<$FloatBox>
			<FavoriteWrapper>
				<StoreFavorite store={store} isLoading={props.isLoading} />
			</FavoriteWrapper>

			<$Waiter isLoading={props.isLoading}>
				<$Center>
					{!!store && (
						<>
							{store.logoUrl && (
								<Logo
									url={imageUrlWithSize(store.logoUrl, {
										h: '100',
										format: 'png',
									})}
								/>
							)}
							{store.type === 'NETWORK' && (
								<>
									<NetworkDescription store={store} />
									<RedirectButton
										disabled={props.isDisabled}
										to={
											props.onProceedClick
												? { onClick: props.onProceedClick }
												: { local: `/out/${store.id}` }
										}
										text={props.proceedButtonText || 'Till butik'}
									/>
									{(store.bestOffer?.isMultipleOffers || !store.bestOffer?.offer?.isStoreWide) && (
										<>
											<OfferList
												onToggleCollapse={() => setCollapseOffers(!collapseOffers)}
												collapsed={collapseOffers}
												offers={store.offers}
											/>
										</>
									)}
								</>
							)}

							{store.type === 'GIFTCARD' && (
								<>
									<GiftcardDescription store={store} />
									{props.giftcardPurchaseSectionOverride || <GiftcardPurchase store={store} />}
								</>
							)}
						</>
					)}
				</$Center>
			</$Waiter>
		</$FloatBox>
	);
}
